import { DataTableV2Component, dataTableV2Template } from './DataTableV2';
import styles from './DataTableV2.styles.scss';
import { withStylePrefix } from '../common/withStylePrefix';
const dataTableV2Definition = {
    baseName: 'data-table-v2',
    styles: withStylePrefix(styles),
    template: dataTableV2Template,
};
export const chameleonDataTableV2 = DataTableV2Component.compose(dataTableV2Definition);
